// Toast
function showToast(msg, type = '') {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.className = 'toast show ' + type;
  clearTimeout(t._timer);
  t._timer = setTimeout(() => { t.className = 'toast'; }, 3000);
}

// Cart
function openCart() {
  document.getElementById('cart-drawer').classList.add('open');
  document.getElementById('cart-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  refreshCart();
}
function closeCart() {
  document.getElementById('cart-drawer').classList.remove('open');
  document.getElementById('cart-overlay').classList.remove('open');
  document.body.style.overflow = '';
}
function openMenu() {
  document.getElementById('mobile-menu').classList.add('open');
  document.getElementById('menu-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeMenu() {
  document.getElementById('mobile-menu').classList.remove('open');
  document.getElementById('menu-overlay').classList.remove('open');
  document.body.style.overflow = '';
}

async function refreshCart() {
  try {
    const r = await fetch('/cart.js');
    const cart = await r.json();
    updateCartBadge(cart.item_count);
    renderCartDrawer(cart);
  } catch(e) {}
}

function updateCartBadge(count) {
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

function renderCartDrawer(cart) {
  const body = document.getElementById('cart-body');
  const foot = document.getElementById('cart-foot');
  const total = document.getElementById('cart-total');
  if (!body) return;
  if (cart.item_count === 0) {
    body.innerHTML = '<div class="cart-empty"><div style="font-size:3rem">🛒</div><p>Your cart is empty</p><a href="/collections/all" class="btn btn-primary" onclick="closeCart()">Browse Products</a></div>';
    if (foot) foot.style.display = 'none';
    return;
  }
  body.innerHTML = cart.items.map(item => `
    <div class="cart-item">
      <img src="${item.image || ''}" alt="${item.title}" onerror="this.style.display='none'">
      <div class="cart-item-info">
        <div class="cart-item-title">${item.title}</div>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<div style="font-size:.75rem;color:var(--text3)">${item.variant_title}</div>` : ''}
        <div class="cart-item-price">${formatMoney(item.final_price)}</div>
        <div class="cart-item-qty">
          <button class="qty-btn" onclick="updateItem(${item.key}, ${item.quantity - 1})">−</button>
          <span>${item.quantity}</span>
          <button class="qty-btn" onclick="updateItem(${item.key}, ${item.quantity + 1})">+</button>
          <button class="qty-btn" onclick="updateItem(${item.key}, 0)" style="margin-left:8px;font-size:.75rem;color:var(--text3)">✕</button>
        </div>
      </div>
    </div>
  `).join('');
  if (foot) foot.style.display = 'block';
  if (total) total.textContent = formatMoney(cart.total_price);
}

async function addToCart(variantId, qty = 1, btn) {
  if (btn) { btn.disabled = true; btn.textContent = '...'; }
  try {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    if (!r.ok) throw new Error();
    await refreshCart();
    openCart();
    showToast('Added to cart!', 'success');
  } catch(e) {
    showToast('Could not add to cart', 'error');
  } finally {
    if (btn) { btn.disabled = false; btn.innerHTML = '+'; }
  }
}

async function updateItem(key, qty) {
  try {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    if (!r.ok) {
      const err = await r.json().catch(() => ({}));
      showToast(err.description || 'Not enough stock available.', 'error');
      return;
    }
    await refreshCart();
  } catch(e) {
    showToast('Something went wrong. Please try again.', 'error');
  }
}

function formatMoney(cents) {
  return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

// Hero Slider
function initHero() {
  const track = document.getElementById('hero-track');
  if (!track) return;
  const slides = track.querySelectorAll('.hero-slide');
  const dots = document.querySelectorAll('.hero-dot');
  if (!slides.length) return;
  let cur = 0;
  const delay = parseInt(track.dataset.autoplay, 10) || 4000;
  let timer = setInterval(next, delay);

  function go(n) {
    cur = (n + slides.length) % slides.length;
    track.style.transform = `translateX(-${cur * 100}%)`;
    dots.forEach((d, i) => d.classList.toggle('active', i === cur));
  }
  function next() { go(cur + 1); }
  function prev() { go(cur - 1); }

  document.getElementById('hero-next')?.addEventListener('click', () => { clearInterval(timer); next(); timer = setInterval(next, delay); });
  document.getElementById('hero-prev')?.addEventListener('click', () => { clearInterval(timer); prev(); timer = setInterval(next, delay); });
  dots.forEach((d, i) => d.addEventListener('click', () => { clearInterval(timer); go(i); timer = setInterval(next, delay); }));

  // Touch swipe
  let sx = 0;
  track.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, { passive: true });
  track.addEventListener('touchend', e => {
    const dx = e.changedTouches[0].clientX - sx;
    if (Math.abs(dx) > 50) { clearInterval(timer); dx < 0 ? next() : prev(); timer = setInterval(next, delay); }
  });
}

// Video
function loadVideo(containerId, url) {
  const el = document.getElementById(containerId);
  if (!el) return;
  el.innerHTML = `<iframe src="${url}" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
}

// Wishlist
const Wishlist = {
  get() { try { return JSON.parse(localStorage.getItem('gb_wishlist') || '[]'); } catch(e) { return []; } },
  save(list) { localStorage.setItem('gb_wishlist', JSON.stringify(list)); },
  has(id) { return this.get().includes(String(id)); },
  toggle(id, btn) {
    let list = this.get();
    const sid = String(id);
    if (list.includes(sid)) {
      list = list.filter(i => i !== sid);
      if (btn) btn.classList.remove('active');
      showToast('Removed from wishlist');
    } else {
      list.push(sid);
      if (btn) btn.classList.add('active');
      showToast('Added to wishlist ❤️', 'success');
    }
    this.save(list);
  },
  initButtons() {
    document.querySelectorAll('.wishlist-btn[data-id]').forEach(btn => {
      if (this.has(btn.dataset.id)) btn.classList.add('active');
    });
  }
};

// PDP
function pdpSetImg(src, thumb) {
  const main = document.getElementById('pdp-main-img');
  if (main) main.src = src;
  document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
  if (thumb) thumb.classList.add('active');
}
function pdpQty(delta) {
  const el = document.getElementById('pdp-qty');
  if (!el) return;
  el.textContent = Math.max(1, parseInt(el.textContent) + delta);
}
function pdpAddToCart() {
  const sel = document.querySelector('.variant-select');
  const qty = parseInt(document.getElementById('pdp-qty')?.textContent || 1);
  const variantId = sel ? sel.value : window.gbVariantId;
  if (!variantId) return showToast('Please select a variant', 'error');
  addToCart(variantId, qty, document.getElementById('pdp-add-btn'));
}
function pdpBuyNow() {
  const sel = document.querySelector('.variant-select');
  const variantId = sel ? sel.value : window.gbVariantId;
  const qty = parseInt(document.getElementById('pdp-qty')?.textContent || 1);
  if (!variantId) return showToast('Please select a variant', 'error');
  window.location = `/cart/${variantId}:${qty}`;
}
function pdpTab(name, btn) {
  document.querySelectorAll('.tab-content').forEach(t => t.classList.remove('active'));
  document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
  const el = document.getElementById('tab-' + name);
  if (el) el.classList.add('active');
  if (btn) btn.classList.add('active');
}
function selectVariant(btn, id) {
  document.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  window.gbVariantId = id;
}

// Scroll reveal
function initReveal() {
  if (!window.IntersectionObserver) return;
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.style.opacity = '1'; e.target.style.transform = 'translateY(0)'; obs.unobserve(e.target); } });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity .5s ease, transform .5s ease';
    obs.observe(el);
  });
}

// Init
document.addEventListener('DOMContentLoaded', () => {
  refreshCart();
  initHero();
  initReveal();
  Wishlist.initButtons();
});
